import script from "./FieldHelpIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldHelpIcon.vue?vue&type=script&setup=true&lang=js"

import "./FieldHelpIcon.vue?vue&type=style&index=0&id=460b2dc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460b2dc4"]])

export default __exports__